export default __webpack_public_path__ + "static/media/card2-3.990b43b9.jpg";